import ar from "./ar.json"; // Arabic
import cn from "./cn.json"; // Chinese
import en from "./en.json"; // English
import fr from "./fr.json"; // French
import gr from "./gr.json"; // German
import it from "./it.json"; // italian
import pe from "./pe.json"; // Persian
import po from "./po.json"; // Portuguese
import ru from "./ru.json"; // Russian
import sp from "./sp.json"; // Spanish
import tr from "./tr.json"; // Turkish

export default { ar, cn, en, fr, gr, it, pe, po, ru, sp, tr };
